import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2ddc0417"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "contentBox"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [/*#__PURE__*/_createTextVNode("您好，请使用微信扫一扫"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("联系康信通产品经理")], -1));
const _hoisted_4 = {
  class: "qrcode"
};
const _hoisted_5 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["consulting", {
      hidden: !$props.visible
    }]),
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => _ctx.$emit('hide'), ["self"]))
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("button", {
    class: "close",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('hide'))
  }, [_createElementVNode("img", {
    src: $data.closeImg,
    width: "18",
    height: "18"
  }, null, 8, _hoisted_2)]), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: $data.qrcodeImg,
    width: "160",
    height: "160"
  }, null, 8, _hoisted_5)])])], 2);
}